if (!customElements.get('products-carousel')) {
  customElements.define('products-carousel',
    class ProductsCarousel extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.setSlider();
      }
    
      setSlider() {
        // console.log(this.dataset.desktopColumns);
        // console.log(this.dataset.mobileColumns);
        
        const swiper = new Swiper(`#Slider-${this.dataset.sectionId}`, {
          // Optional parameters
          loop: true,
          spaceBetween: 30,
          centeredSlides: true,
          // slidesPerView: parseInt(this.dataset.mobileColumns),
          grabCursor: true,
          slidesPerView: "auto",
          
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
            
          // If we need pagination
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          
          breakpoints: {
            750: {
              spaceBetween: 40,
              centeredSlides: false,
              slidesPerView: "auto",
            },
          },
        });
      }
    }
  );
}
